import { createComponent } from '@carvana/merch-components';

export const Band = createComponent('div', {
  className: 'bg-background-primary-subtle py-24 sm:py-32'
});

export const BandContent = createComponent('div', {
  className:
    'mx-auto flex w-full max-w-[1352px] flex-col gap-16 px-2xl sm:px-3xl md:flex-row md:items-center md:gap-4xl lg:justify-between lg:px-4xl'
});

export const BandHeading = createComponent('p', {
  className: 'text-text-strong t-heading-lg sm:t-heading-xl m-0 shrink-0'
});

export const SearchWrapper = createComponent('div', {
  className: 'w-full md:flex-1'
});
